import { render, staticRenderFns } from "./VisitPointEditTabAccount.vue?vue&type=template&id=80390802"
import script from "./VisitPointEditTabAccount.vue?vue&type=script&lang=js"
export * from "./VisitPointEditTabAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports